var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 461.951,
    height: 464.291,
    viewBox: "0 0 461.951 464.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vision",
    transform: "translate(-6.973 -23.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5288",
    "data-name": "Group 5288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4602",
    "data-name": "Path 4602",
    d: "M319.055,412.946l75.6,75,14.762-.04,5.25-74.964Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4603",
    "data-name": "Path 4603",
    d: "M380.53,420.049l-76.18,67.9,53.212-.08,44.845-37.72Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5289",
    "data-name": "Group 5289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4604",
    "data-name": "Path 4604",
    d: "M373.365,226.014l93.9,87.041,1.655-90.285Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4605",
    "data-name": "Path 4605",
    d: "M436.633,229.77,182.655,487.91H232.7l226.816-228.8Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5290",
    "data-name": "Group 5290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4606",
    "data-name": "Path 4606",
    d: "M107.07,325.36l90.9,90.177,4.718-90.177Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    d: "M170.174,331.261,6.973,487.91H59.559L192.052,361.362Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5291",
    "data-name": "Group 5291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    d: "M186.316,294.4l129.766,128.74V294.4Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4609",
    "data-name": "Path 4609",
    d: "M271.939,297.3C269,299.654,82.2,487.91,82.2,487.91h80.479L309.535,340.187Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sun"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5317",
    "data-name": "Group 5317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5292",
    "data-name": "Group 5292"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1049",
    "data-name": "Ellipse 1049",
    cx: 12.834,
    cy: 12.834,
    r: 12.834,
    transform: "matrix(0.925, -0.38, 0.38, 0.925, 77.241, 68.597)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5294",
    "data-name": "Group 5294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5293",
    "data-name": "Group 5293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4610",
    "data-name": "Path 4610",
    d: "M92.159,104.293A51.852,51.852,0,0,1,92.024,99a51.848,51.848,0,0,1,.135-5.294A51.844,51.844,0,0,1,92.294,99,51.848,51.848,0,0,1,92.159,104.293Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5296",
    "data-name": "Group 5296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5295",
    "data-name": "Group 5295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4611",
    "data-name": "Path 4611",
    d: "M84.764,90.722c.064.037-1.143,2.248-2.7,4.938s-2.866,4.841-2.93,4.8,1.142-2.248,2.7-4.939S84.7,90.684,84.764,90.722Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5298",
    "data-name": "Group 5298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5297",
    "data-name": "Group 5297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    d: "M77.173,86a28.768,28.768,0,0,1-3,2.555,28.69,28.69,0,0,1-3.165,2.343,28.768,28.768,0,0,1,3-2.555A28.847,28.847,0,0,1,77.173,86Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5300",
    "data-name": "Group 5300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5299",
    "data-name": "Group 5299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4613",
    "data-name": "Path 4613",
    d: "M104.962,99.078a7.508,7.508,0,0,1-.339-1.3c-.184-.808-.446-1.921-.773-3.141s-.661-2.315-.907-3.106a7.5,7.5,0,0,1-.36-1.3,6.045,6.045,0,0,1,.541,1.235c.293.779.656,1.871.987,3.1s.563,2.354.7,3.174A6.014,6.014,0,0,1,104.962,99.078Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5302",
    "data-name": "Group 5302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5301",
    "data-name": "Group 5301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4614",
    "data-name": "Path 4614",
    d: "M117.979,89.841a44.637,44.637,0,0,1-3.793-3.136,44.929,44.929,0,0,1-3.616-3.34,44.959,44.959,0,0,1,3.793,3.137A45.027,45.027,0,0,1,117.979,89.841Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5304",
    "data-name": "Group 5304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5303",
    "data-name": "Group 5303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4615",
    "data-name": "Path 4615",
    d: "M122.965,77.148a10.653,10.653,0,0,1-1.548-.222c-.951-.159-2.266-.362-3.725-.53s-2.787-.267-3.748-.328a10.713,10.713,0,0,1-1.558-.133,7.793,7.793,0,0,1,1.565-.058c.967.013,2.3.082,3.772.25s2.785.4,3.73.611A7.857,7.857,0,0,1,122.965,77.148Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5306",
    "data-name": "Group 5306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5305",
    "data-name": "Group 5305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4616",
    "data-name": "Path 4616",
    d: "M122.981,64.666c.017.072-2.761.811-6.205,1.65s-6.252,1.461-6.27,1.388,2.76-.811,6.206-1.65S122.963,64.593,122.981,64.666Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5308",
    "data-name": "Group 5308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5307",
    "data-name": "Group 5307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4617",
    "data-name": "Path 4617",
    d: "M108.479,50.123c.062.041-1.267,2.161-2.969,4.735s-3.132,4.629-3.194,4.588,1.267-2.162,2.969-4.737S108.417,50.082,108.479,50.123Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5310",
    "data-name": "Group 5310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5309",
    "data-name": "Group 5309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4618",
    "data-name": "Path 4618",
    d: "M94.087,47.085a12.608,12.608,0,0,1,.019,1.762c-.016,1.086-.037,2.587-.036,4.244s.027,3.158.045,4.245A12.314,12.314,0,0,1,94.1,59.1a10.5,10.5,0,0,1-.176-1.755c-.067-1.086-.122-2.59-.124-4.252s.05-3.165.115-4.251A10.427,10.427,0,0,1,94.087,47.085Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5312",
    "data-name": "Group 5312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5311",
    "data-name": "Group 5311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4619",
    "data-name": "Path 4619",
    d: "M83.188,60.659c-.063.038-1.415-2.058-3.019-4.682s-2.852-4.784-2.789-4.823,1.416,2.057,3.02,4.682S83.252,60.62,83.188,60.659Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5314",
    "data-name": "Group 5314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5313",
    "data-name": "Group 5313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4620",
    "data-name": "Path 4620",
    d: "M76.678,66.192a6.406,6.406,0,0,1-1.365-.217c-.834-.175-1.979-.455-3.228-.823s-2.362-.755-3.158-1.06a6.449,6.449,0,0,1-1.264-.559,7.713,7.713,0,0,1,1.327.379c.81.258,1.929.614,3.172.981s2.375.674,3.2.9A7.7,7.7,0,0,1,76.678,66.192Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5316",
    "data-name": "Group 5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5315",
    "data-name": "Group 5315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4621",
    "data-name": "Path 4621",
    d: "M73.833,76.052a31.677,31.677,0,0,1-4.1.529,31.785,31.785,0,0,1-4.121.261,31.356,31.356,0,0,1,4.1-.53A31.456,31.456,0,0,1,73.833,76.052Z",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5321",
    "data-name": "Group 5321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5320",
    "data-name": "Group 5320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5319",
    "data-name": "Group 5319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4622",
    "data-name": "Path 4622",
    d: "M456.143,358.1c.524-3.8-4.841-6.929-8.873-7.254-1.922-.155-3.919.139-5.741-.5-3.946-1.375-5.522-6.473-9.372-8.1-2.879-1.214-6.193-.133-8.984,1.271s-5.548,3.172-8.666,3.372c-2.712.173-5.657-.833-8.029.492-1.769.987-2.7,3.025-4.324,4.227a10.31,10.31,0,0,1-5.653,1.532,15.923,15.923,0,0,0-5.827.953c-1.8.824-3.291,2.729-2.917,4.675Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5318",
    "data-name": "Group 5318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4623",
    "data-name": "Path 4623",
    d: "M456.143,358.1a2.155,2.155,0,0,1-.329.022l-1,.029-3.9.076-14.486.221-48.67.586-.215,0-.042-.213a4.1,4.1,0,0,1,.895-3.244,6.035,6.035,0,0,1,2.844-1.986c2.562-.871,5.205-.5,7.631-.955a7.161,7.161,0,0,0,3.312-1.375,24.3,24.3,0,0,0,2.474-2.684,7.346,7.346,0,0,1,1.415-1.241,5.485,5.485,0,0,1,1.744-.719,12.533,12.533,0,0,1,3.62-.087,18.46,18.46,0,0,0,3.434.083,11.944,11.944,0,0,0,3.22-.845c2.06-.823,3.921-1.988,5.876-2.879a12.731,12.731,0,0,1,6.081-1.355,6.938,6.938,0,0,1,2.882.866,10.061,10.061,0,0,1,2.242,1.812c1.3,1.355,2.316,2.822,3.505,4.005a7.206,7.206,0,0,0,4.062,2.258c1.485.236,2.936.108,4.293.207a12.8,12.8,0,0,1,6.461,2.418,6.544,6.544,0,0,1,2.6,3.474,3.677,3.677,0,0,1,.053,1.524,5.867,5.867,0,0,0-.155-1.5,6.533,6.533,0,0,0-2.615-3.337,12.694,12.694,0,0,0-6.359-2.291c-1.331-.085-2.782.059-4.328-.171a7.539,7.539,0,0,1-4.268-2.324c-1.228-1.206-2.26-2.672-3.535-3.986a9.69,9.69,0,0,0-2.157-1.728,6.52,6.52,0,0,0-2.711-.8,12.313,12.313,0,0,0-5.858,1.341c-1.912.878-3.778,2.056-5.888,2.908a12.427,12.427,0,0,1-3.346.886,18.945,18.945,0,0,1-3.525-.074,12.137,12.137,0,0,0-3.471.083,5.331,5.331,0,0,0-2.893,1.813,24.248,24.248,0,0,1-2.527,2.74,7.674,7.674,0,0,1-3.543,1.484c-2.532.461-5.154.11-7.552.937a5.515,5.515,0,0,0-2.6,1.812,3.587,3.587,0,0,0-.8,2.828l-.257-.21,48.5-.373,14.541-.066h3.952l1.033.009A2.606,2.606,0,0,1,456.143,358.1Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5325",
    "data-name": "Group 5325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5324",
    "data-name": "Group 5324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5323",
    "data-name": "Group 5323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4624",
    "data-name": "Path 4624",
    d: "M241.3,441.8c.695-5.05-6.431-9.2-11.785-9.635-2.553-.205-5.206.185-7.625-.658-5.241-1.827-7.334-8.6-12.448-10.755-3.823-1.612-8.225-.177-11.932,1.689s-7.369,4.213-11.51,4.478c-3.6.23-7.513-1.106-10.665.654-2.348,1.311-3.578,4.017-5.743,5.614-2.117,1.561-4.879,1.892-7.507,2.035s-5.347.169-7.739,1.265-4.372,3.625-3.875,6.209Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5322",
    "data-name": "Group 5322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4625",
    "data-name": "Path 4625",
    d: "M241.3,441.8s-.144.015-.443.024l-1.337.032-5.184.089-19.248.268-64.615.743-.215,0-.042-.213a5.366,5.366,0,0,1,1.172-4.242,7.948,7.948,0,0,1,3.739-2.609c3.376-1.149,6.883-.663,10.122-1.265a9.592,9.592,0,0,0,4.437-1.844,32.2,32.2,0,0,0,3.294-3.573,9.62,9.62,0,0,1,1.864-1.636,7.2,7.2,0,0,1,2.288-.944,16.629,16.629,0,0,1,4.784-.115,24.615,24.615,0,0,0,4.576.109,15.925,15.925,0,0,0,4.3-1.129c2.745-1.1,5.217-2.647,7.806-3.828a16.815,16.815,0,0,1,8.041-1.8,9.135,9.135,0,0,1,3.8,1.138A13.293,13.293,0,0,1,213.4,423.4c1.719,1.793,3.074,3.741,4.66,5.316a9.627,9.627,0,0,0,5.429,3.01c1.982.312,3.909.14,5.707.269a15.857,15.857,0,0,1,4.876,1.158,17.025,17.025,0,0,1,3.69,2.033,11.316,11.316,0,0,1,2.385,2.371,6.617,6.617,0,0,1,1.066,2.22,4.64,4.64,0,0,1,.136,1.515c-.027.345-.048.5-.048.5s-.005-.188,0-.522a5.087,5.087,0,0,0-.187-1.47,8.687,8.687,0,0,0-3.47-4.455,16.981,16.981,0,0,0-3.661-1.965,15.667,15.667,0,0,0-4.8-1.1c-1.772-.115-3.7.074-5.742-.233a9.97,9.97,0,0,1-5.635-3.075c-1.624-1.6-2.993-3.546-4.69-5.3a12.922,12.922,0,0,0-2.879-2.309A8.71,8.71,0,0,0,206.6,420.3a16.418,16.418,0,0,0-7.818,1.783c-2.546,1.169-5.024,2.731-7.818,3.858a16.431,16.431,0,0,1-4.424,1.17,25.006,25.006,0,0,1-4.666-.1,16.2,16.2,0,0,0-4.635.111,6.712,6.712,0,0,0-2.123.878,9.165,9.165,0,0,0-1.762,1.554,32.184,32.184,0,0,1-3.349,3.63,10.086,10.086,0,0,1-4.668,1.953c-3.345.611-6.83.142-10.042,1.247a7.43,7.43,0,0,0-3.5,2.436,4.851,4.851,0,0,0-1.074,3.825l-.257-.21,64.444-.531,19.3-.113,5.24-.013,1.367.005C241.129,441.784,241.3,441.8,241.3,441.8Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5329",
    "data-name": "Group 5329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5328",
    "data-name": "Group 5328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5327",
    "data-name": "Group 5327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4626",
    "data-name": "Path 4626",
    d: "M148.818,203.311c.583-4.238-5.4-7.724-9.892-8.087-2.143-.172-4.369.155-6.4-.552-4.4-1.534-6.156-7.217-10.448-9.027-3.209-1.354-6.9-.149-10.015,1.417s-6.185,3.536-9.661,3.759c-3.023.193-6.307-.928-8.952.549-1.971,1.1-3,3.372-4.82,4.711-1.777,1.311-4.1,1.589-6.3,1.709s-4.488.142-6.5,1.062-3.669,3.042-3.253,5.211Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5326",
    "data-name": "Group 5326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4627",
    "data-name": "Path 4627",
    d: "M148.818,203.311a2.629,2.629,0,0,1-.37.023l-1.119.029-4.347.081-16.152.237-54.247.641-.215,0-.042-.213a4.547,4.547,0,0,1,.991-3.594,6.7,6.7,0,0,1,3.158-2.2c2.846-.968,5.792-.559,8.5-1.063a8.014,8.014,0,0,0,3.706-1.54,26.915,26.915,0,0,0,2.76-3,8.143,8.143,0,0,1,1.573-1.379,6.1,6.1,0,0,1,1.934-.8,13.992,13.992,0,0,1,4.027-.1,20.679,20.679,0,0,0,3.833.092,13.358,13.358,0,0,0,3.6-.944c2.3-.92,4.375-2.219,6.551-3.212a14.159,14.159,0,0,1,6.767-1.509,7.705,7.705,0,0,1,3.2.961,11.224,11.224,0,0,1,2.494,2.015c1.445,1.509,2.581,3.144,3.909,4.464a8.058,8.058,0,0,0,4.54,2.521c1.659.263,3.277.119,4.788.229a14.253,14.253,0,0,1,7.2,2.688,7.285,7.285,0,0,1,2.9,3.865,3.84,3.84,0,0,1,.11,1.275c-.025.29-.044.422-.044.422s-.007-.161-.006-.441a4.285,4.285,0,0,0-.161-1.23,7.3,7.3,0,0,0-2.914-3.728,14.167,14.167,0,0,0-7.1-2.561c-1.485-.1-3.1.065-4.822-.192a8.39,8.39,0,0,1-4.747-2.587c-1.366-1.343-2.516-2.978-3.938-4.445a10.83,10.83,0,0,0-2.41-1.931,7.274,7.274,0,0,0-3.032-.894,13.741,13.741,0,0,0-6.544,1.495c-2.134.98-4.214,2.292-6.563,3.24a13.807,13.807,0,0,1-3.723.985,20.91,20.91,0,0,1-3.924-.083,13.6,13.6,0,0,0-3.878.093,5.972,5.972,0,0,0-3.24,2.03A27.159,27.159,0,0,1,89,196.114a8.512,8.512,0,0,1-3.936,1.647c-2.817.514-5.741.121-8.423,1.046a6.178,6.178,0,0,0-2.917,2.03,4.027,4.027,0,0,0-.894,3.177l-.257-.21,54.077-.428,16.207-.082,4.4-.006,1.151.008A3.12,3.12,0,0,1,148.818,203.311Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5333",
    "data-name": "Group 5333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5332",
    "data-name": "Group 5332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5331",
    "data-name": "Group 5331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4628",
    "data-name": "Path 4628",
    d: "M421.435,92.918c.459-3.331-4.243-6.071-7.775-6.356-1.685-.136-3.435.122-5.031-.435-3.458-1.205-4.839-5.672-8.213-7.1-2.523-1.063-5.427-.116-7.873,1.115s-4.862,2.779-7.594,2.954c-2.377.152-4.957-.729-7.037.432-1.549.865-2.361,2.65-3.789,3.7a9.046,9.046,0,0,1-4.953,1.343,13.946,13.946,0,0,0-5.107.834c-1.578.723-2.884,2.392-2.556,4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5330",
    "data-name": "Group 5330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4629",
    "data-name": "Path 4629",
    d: "M421.435,92.918a1.39,1.39,0,0,1-.287.022l-.876.028-3.411.071-12.691.2-42.661.527-.215,0-.042-.213a3.633,3.633,0,0,1,.79-2.87,5.334,5.334,0,0,1,2.508-1.75c2.255-.766,4.572-.442,6.692-.838a6.242,6.242,0,0,0,2.888-1.2,21.138,21.138,0,0,0,2.164-2.348,5.16,5.16,0,0,1,2.785-1.727,11.034,11.034,0,0,1,3.182-.076,16.162,16.162,0,0,0,3,.073,10.433,10.433,0,0,0,2.813-.737c1.8-.721,3.433-1.74,5.149-2.522a11.171,11.171,0,0,1,5.343-1.188,6.1,6.1,0,0,1,2.536.763,8.816,8.816,0,0,1,1.969,1.593c1.138,1.19,2.03,2.476,3.07,3.511a6.291,6.291,0,0,0,3.547,1.974c1.3.207,2.569.1,3.76.184a11.214,11.214,0,0,1,5.668,2.127,5.735,5.735,0,0,1,2.275,3.052,3.146,3.146,0,0,1,.04,1.337,5.329,5.329,0,0,0-.142-1.31A5.736,5.736,0,0,0,419,88.692a11.128,11.128,0,0,0-5.567-2c-1.165-.074-2.436.054-3.795-.148a6.633,6.633,0,0,1-3.753-2.04c-1.078-1.058-1.984-2.343-3.1-3.492A8.473,8.473,0,0,0,400.9,79.5a5.671,5.671,0,0,0-2.365-.7,10.769,10.769,0,0,0-5.121,1.174c-1.672.769-3.308,1.8-5.16,2.55a10.907,10.907,0,0,1-2.94.779,16.641,16.641,0,0,1-3.094-.064,10.6,10.6,0,0,0-3.033.072,4.641,4.641,0,0,0-2.518,1.58,21.294,21.294,0,0,1-2.219,2.4,6.756,6.756,0,0,1-3.119,1.307c-2.225.4-4.521.1-6.612.819a4.813,4.813,0,0,0-2.268,1.578,3.113,3.113,0,0,0-.692,2.453l-.257-.211,42.491-.313,12.746-.048,3.466,0,.908.01A2.42,2.42,0,0,1,421.435,92.918Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5679",
    "data-name": "Group 5679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5418",
    "data-name": "Group 5418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5417",
    "data-name": "Group 5417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5416",
    "data-name": "Group 5416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5344",
    "data-name": "Group 5344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5343",
    "data-name": "Group 5343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5342",
    "data-name": "Group 5342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5340",
    "data-name": "Group 5340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5339",
    "data-name": "Group 5339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5338",
    "data-name": "Group 5338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5337",
    "data-name": "Group 5337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5336",
    "data-name": "Group 5336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5335",
    "data-name": "Group 5335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5334",
    "data-name": "Group 5334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4630",
    "data-name": "Path 4630",
    d: "M247.089,268.688l-.719,16.445s16.475,6.254,16.638,9.306l-31.937-.249.069-25.67Z",
    fill: "#455a64"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5356",
    "data-name": "Group 5356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5355",
    "data-name": "Group 5355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5354",
    "data-name": "Group 5354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5353",
    "data-name": "Group 5353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5352",
    "data-name": "Group 5352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5351",
    "data-name": "Group 5351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5350",
    "data-name": "Group 5350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5349",
    "data-name": "Group 5349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5348",
    "data-name": "Group 5348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5347",
    "data-name": "Group 5347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5346",
    "data-name": "Group 5346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5345",
    "data-name": "Group 5345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4631",
    "data-name": "Path 4631",
    d: "M236.505,283.672a1.306,1.306,0,0,0-.913,1.482,1.254,1.254,0,0,0,1.46.918,1.376,1.376,0,0,0,.959-1.574,1.3,1.3,0,0,0-1.625-.787",
    fill: "#e0e0e0"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5367",
    "data-name": "Group 5367",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5366",
    "data-name": "Group 5366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5365",
    "data-name": "Group 5365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5364",
    "data-name": "Group 5364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5363",
    "data-name": "Group 5363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5362",
    "data-name": "Group 5362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5361",
    "data-name": "Group 5361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5360",
    "data-name": "Group 5360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5359",
    "data-name": "Group 5359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5358",
    "data-name": "Group 5358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5357",
    "data-name": "Group 5357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4632",
    "data-name": "Path 4632",
    d: "M231.071,294.191l.108-2.588,30.58,1.206s1.417.63,1.249,1.63Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5379",
    "data-name": "Group 5379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5378",
    "data-name": "Group 5378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5377",
    "data-name": "Group 5377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5376",
    "data-name": "Group 5376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5375",
    "data-name": "Group 5375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5374",
    "data-name": "Group 5374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5373",
    "data-name": "Group 5373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5372",
    "data-name": "Group 5372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5371",
    "data-name": "Group 5371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5370",
    "data-name": "Group 5370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5369",
    "data-name": "Group 5369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5368",
    "data-name": "Group 5368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4633",
    "data-name": "Path 4633",
    d: "M246.889,284.975c-.006.156-.787.22-1.558.716-.784.475-1.185,1.148-1.328,1.084-.143-.031.1-.961,1.041-1.545S246.924,284.832,246.889,284.975Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5391",
    "data-name": "Group 5391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5390",
    "data-name": "Group 5390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5389",
    "data-name": "Group 5389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5388",
    "data-name": "Group 5388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5387",
    "data-name": "Group 5387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5385",
    "data-name": "Group 5385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5384",
    "data-name": "Group 5384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5383",
    "data-name": "Group 5383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5382",
    "data-name": "Group 5382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5381",
    "data-name": "Group 5381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5380",
    "data-name": "Group 5380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4634",
    "data-name": "Path 4634",
    d: "M250.228,286.386c.034.152-.643.412-1.178,1.067-.554.64-.693,1.352-.848,1.344-.147.023-.248-.891.433-1.693S250.226,286.238,250.228,286.386Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5402",
    "data-name": "Group 5402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5401",
    "data-name": "Group 5401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5400",
    "data-name": "Group 5400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5399",
    "data-name": "Group 5399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5398",
    "data-name": "Group 5398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5397",
    "data-name": "Group 5397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5396",
    "data-name": "Group 5396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5393",
    "data-name": "Group 5393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5392",
    "data-name": "Group 5392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4635",
    "data-name": "Path 4635",
    d: "M252.1,290.41c-.142.032-.353-.749.054-1.6s1.139-1.185,1.205-1.054c.087.129-.39.583-.714,1.287C252.3,289.739,252.254,290.4,252.1,290.41Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5415",
    "data-name": "Group 5415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5414",
    "data-name": "Group 5414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5413",
    "data-name": "Group 5413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5412",
    "data-name": "Group 5412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5411",
    "data-name": "Group 5411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5410",
    "data-name": "Group 5410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5409",
    "data-name": "Group 5409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5408",
    "data-name": "Group 5408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5407",
    "data-name": "Group 5407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5406",
    "data-name": "Group 5406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5405",
    "data-name": "Group 5405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4636",
    "data-name": "Path 4636",
    d: "M246.637,281.209c-.066.141-.78-.079-1.662-.026-.883.035-1.571.325-1.652.191-.089-.114.585-.686,1.625-.734S246.715,281.087,246.637,281.209Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5503",
    "data-name": "Group 5503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5502",
    "data-name": "Group 5502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5501",
    "data-name": "Group 5501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5429",
    "data-name": "Group 5429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5428",
    "data-name": "Group 5428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5427",
    "data-name": "Group 5427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5426",
    "data-name": "Group 5426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5425",
    "data-name": "Group 5425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5424",
    "data-name": "Group 5424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5423",
    "data-name": "Group 5423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5422",
    "data-name": "Group 5422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5421",
    "data-name": "Group 5421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5420",
    "data-name": "Group 5420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5419",
    "data-name": "Group 5419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    d: "M296.711,268.688l-.719,16.445s16.475,6.254,16.638,9.306l-31.937-.249.069-25.67Z",
    fill: "#455a64"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5441",
    "data-name": "Group 5441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    "data-name": "Group 5438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5437",
    "data-name": "Group 5437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5436",
    "data-name": "Group 5436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5435",
    "data-name": "Group 5435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5434",
    "data-name": "Group 5434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5433",
    "data-name": "Group 5433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5432",
    "data-name": "Group 5432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5431",
    "data-name": "Group 5431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5430",
    "data-name": "Group 5430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4638",
    "data-name": "Path 4638",
    d: "M286.128,283.672a1.305,1.305,0,0,0-.914,1.482,1.255,1.255,0,0,0,1.461.918,1.376,1.376,0,0,0,.959-1.574,1.3,1.3,0,0,0-1.625-.787",
    fill: "#e0e0e0"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5452",
    "data-name": "Group 5452",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5451",
    "data-name": "Group 5451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5450",
    "data-name": "Group 5450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5449",
    "data-name": "Group 5449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5448",
    "data-name": "Group 5448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5447",
    "data-name": "Group 5447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5446",
    "data-name": "Group 5446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5445",
    "data-name": "Group 5445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5444",
    "data-name": "Group 5444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5443",
    "data-name": "Group 5443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5442",
    "data-name": "Group 5442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4639",
    "data-name": "Path 4639",
    d: "M280.693,294.191l.108-2.588,30.581,1.206s1.417.63,1.248,1.63Z",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5464",
    "data-name": "Group 5464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5463",
    "data-name": "Group 5463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5462",
    "data-name": "Group 5462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5461",
    "data-name": "Group 5461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5460",
    "data-name": "Group 5460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5459",
    "data-name": "Group 5459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5458",
    "data-name": "Group 5458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5455",
    "data-name": "Group 5455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5453",
    "data-name": "Group 5453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4640",
    "data-name": "Path 4640",
    d: "M296.511,284.975c-.006.156-.786.22-1.557.716-.785.475-1.186,1.148-1.329,1.084-.143-.031.1-.961,1.041-1.545S296.546,284.832,296.511,284.975Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5476",
    "data-name": "Group 5476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5475",
    "data-name": "Group 5475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5474",
    "data-name": "Group 5474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5473",
    "data-name": "Group 5473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5472",
    "data-name": "Group 5472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5471",
    "data-name": "Group 5471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5470",
    "data-name": "Group 5470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5469",
    "data-name": "Group 5469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5468",
    "data-name": "Group 5468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5467",
    "data-name": "Group 5467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5466",
    "data-name": "Group 5466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5465",
    "data-name": "Group 5465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4641",
    "data-name": "Path 4641",
    d: "M299.85,286.386c.035.152-.643.412-1.178,1.067-.554.64-.693,1.352-.848,1.344-.147.023-.247-.891.433-1.693S299.848,286.238,299.85,286.386Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5488",
    "data-name": "Group 5488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5487",
    "data-name": "Group 5487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5485",
    "data-name": "Group 5485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5484",
    "data-name": "Group 5484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5483",
    "data-name": "Group 5483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5482",
    "data-name": "Group 5482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5481",
    "data-name": "Group 5481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5480",
    "data-name": "Group 5480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5479",
    "data-name": "Group 5479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5478",
    "data-name": "Group 5478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5477",
    "data-name": "Group 5477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4642",
    "data-name": "Path 4642",
    d: "M301.722,290.41c-.142.032-.353-.749.054-1.6s1.139-1.185,1.2-1.054c.087.129-.39.583-.714,1.287C301.926,289.739,301.877,290.4,301.722,290.41Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5500",
    "data-name": "Group 5500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5499",
    "data-name": "Group 5499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5498",
    "data-name": "Group 5498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5497",
    "data-name": "Group 5497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5496",
    "data-name": "Group 5496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5493",
    "data-name": "Group 5493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5492",
    "data-name": "Group 5492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5491",
    "data-name": "Group 5491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5490",
    "data-name": "Group 5490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M296.259,281.209c-.066.141-.78-.079-1.662-.026-.883.035-1.571.325-1.651.191-.09-.114.585-.686,1.624-.734S296.337,281.087,296.259,281.209Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5653",
    "data-name": "Group 5653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5650",
    "data-name": "Group 5650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5649",
    "data-name": "Group 5649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5648",
    "data-name": "Group 5648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5647",
    "data-name": "Group 5647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5646",
    "data-name": "Group 5646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5511",
    "data-name": "Group 5511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5510",
    "data-name": "Group 5510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5509",
    "data-name": "Group 5509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5508",
    "data-name": "Group 5508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5507",
    "data-name": "Group 5507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5506",
    "data-name": "Group 5506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5505",
    "data-name": "Group 5505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5504",
    "data-name": "Group 5504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    d: "M231.223,52.74a56.84,56.84,0,0,1-2.814-9.4,19.855,19.855,0,0,1,.427-9.71c.156-.471,1.517-3.643,2.012-3.613.354.023-.448,2.965-.259,3.265a16.839,16.839,0,0,1,2.248,9.743,44.372,44.372,0,0,1-1.614,9.711",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5520",
    "data-name": "Group 5520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5519",
    "data-name": "Group 5519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5518",
    "data-name": "Group 5518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5517",
    "data-name": "Group 5517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5516",
    "data-name": "Group 5516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5515",
    "data-name": "Group 5515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5514",
    "data-name": "Group 5514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5513",
    "data-name": "Group 5513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5512",
    "data-name": "Group 5512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M232.275,70.174l-1.2-29.71c-.562-8.191,3.105-15.541,11.309-15.877l.892.016A14.535,14.535,0,0,1,257.535,38.22c.452,7.136.862,15.061.748,18.889-.235,7.875-8.135,8.963-8.135,8.963-.017,0,.338,5.708.4,8.02,0,0-.834.606-8.171.866S232.275,70.174,232.275,70.174Z",
    fill: "#ffbf9d"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5529",
    "data-name": "Group 5529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5528",
    "data-name": "Group 5528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5527",
    "data-name": "Group 5527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5526",
    "data-name": "Group 5526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5525",
    "data-name": "Group 5525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5524",
    "data-name": "Group 5524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5523",
    "data-name": "Group 5523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5522",
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5521",
    "data-name": "Group 5521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    d: "M250.148,66.072a19.038,19.038,0,0,1-10.2-3.211s2.4,5.772,10.273,5.2Z",
    fill: "#ff9a6c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5546",
    "data-name": "Group 5546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5545",
    "data-name": "Group 5545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5544",
    "data-name": "Group 5544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5543",
    "data-name": "Group 5543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5542",
    "data-name": "Group 5542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5541",
    "data-name": "Group 5541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5540",
    "data-name": "Group 5540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5539",
    "data-name": "Group 5539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5538",
    "data-name": "Group 5538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5537",
    "data-name": "Group 5537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5533",
    "data-name": "Group 5533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    d: "M254.831,45.372a1.126,1.126,0,0,1-1.1,1.117,1.076,1.076,0,0,1-1.142-1.035,1.125,1.125,0,0,1,1.1-1.117A1.078,1.078,0,0,1,254.831,45.372Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5563",
    "data-name": "Group 5563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5562",
    "data-name": "Group 5562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5561",
    "data-name": "Group 5561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5559",
    "data-name": "Group 5559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5558",
    "data-name": "Group 5558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    "data-name": "Group 5557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5556",
    "data-name": "Group 5556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5554",
    "data-name": "Group 5554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5553",
    "data-name": "Group 5553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5552",
    "data-name": "Group 5552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5551",
    "data-name": "Group 5551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5550",
    "data-name": "Group 5550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5549",
    "data-name": "Group 5549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5548",
    "data-name": "Group 5548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5547",
    "data-name": "Group 5547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4648",
    "data-name": "Path 4648",
    d: "M255.548,42.562c-.142.144-.983-.5-2.194-.519-1.209-.036-2.108.572-2.237.421-.063-.067.084-.329.475-.6a3.089,3.089,0,0,1,1.794-.519,2.964,2.964,0,0,1,1.743.6C255.5,42.23,255.618,42.5,255.548,42.562Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5580",
    "data-name": "Group 5580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5579",
    "data-name": "Group 5579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5578",
    "data-name": "Group 5578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5577",
    "data-name": "Group 5577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5576",
    "data-name": "Group 5576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5575",
    "data-name": "Group 5575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5574",
    "data-name": "Group 5574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5573",
    "data-name": "Group 5573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5572",
    "data-name": "Group 5572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5571",
    "data-name": "Group 5571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5570",
    "data-name": "Group 5570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5569",
    "data-name": "Group 5569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5568",
    "data-name": "Group 5568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5567",
    "data-name": "Group 5567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5566",
    "data-name": "Group 5566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5565",
    "data-name": "Group 5565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4649",
    "data-name": "Path 4649",
    d: "M244.484,45.558c-.142.144-.985-.5-2.194-.519-1.209-.035-2.108.572-2.237.421-.063-.067.082-.329.475-.6a3.089,3.089,0,0,1,1.794-.519,2.967,2.967,0,0,1,1.743.6C244.431,45.226,244.553,45.493,244.484,45.558Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5596",
    "data-name": "Group 5596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5595",
    "data-name": "Group 5595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5594",
    "data-name": "Group 5594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5593",
    "data-name": "Group 5593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5592",
    "data-name": "Group 5592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5591",
    "data-name": "Group 5591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5590",
    "data-name": "Group 5590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5589",
    "data-name": "Group 5589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5588",
    "data-name": "Group 5588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5587",
    "data-name": "Group 5587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5586",
    "data-name": "Group 5586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5585",
    "data-name": "Group 5585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5584",
    "data-name": "Group 5584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5583",
    "data-name": "Group 5583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5582",
    "data-name": "Group 5582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5581",
    "data-name": "Group 5581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4650",
    "data-name": "Path 4650",
    d: "M248.169,52.1a8.122,8.122,0,0,1,1.973-.32c.309-.026.6-.083.659-.293a1.578,1.578,0,0,0-.191-.92q-.417-1.13-.873-2.369A40.52,40.52,0,0,1,247.791,42a40.4,40.4,0,0,1,2.44,6.021q.437,1.248.834,2.384a1.785,1.785,0,0,1,.139,1.215.776.776,0,0,1-.515.444,2.081,2.081,0,0,1-.527.063A7.853,7.853,0,0,1,248.169,52.1Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5608",
    "data-name": "Group 5608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5607",
    "data-name": "Group 5607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5606",
    "data-name": "Group 5606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5605",
    "data-name": "Group 5605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5604",
    "data-name": "Group 5604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5603",
    "data-name": "Group 5603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5602",
    "data-name": "Group 5602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5601",
    "data-name": "Group 5601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5598",
    "data-name": "Group 5598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5597",
    "data-name": "Group 5597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4651",
    "data-name": "Path 4651",
    d: "M244.54,42.334c-.148.317-1.338.053-2.768.1-1.431.014-2.609.325-2.771.015-.071-.149.156-.439.646-.715a4.815,4.815,0,0,1,4.22-.084C244.367,41.9,244.6,42.183,244.54,42.334Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5620",
    "data-name": "Group 5620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5619",
    "data-name": "Group 5619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5618",
    "data-name": "Group 5618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5617",
    "data-name": "Group 5617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5616",
    "data-name": "Group 5616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5615",
    "data-name": "Group 5615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5614",
    "data-name": "Group 5614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5613",
    "data-name": "Group 5613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5612",
    "data-name": "Group 5612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5611",
    "data-name": "Group 5611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5610",
    "data-name": "Group 5610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5609",
    "data-name": "Group 5609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4652",
    "data-name": "Path 4652",
    d: "M256.024,38.032c-.184.322-1.192.249-2.334.483-1.149.2-2.065.638-2.348.4-.127-.115-.034-.417.332-.763a3.7,3.7,0,0,1,1.8-.851,3.649,3.649,0,0,1,1.975.136C255.91,37.63,256.1,37.878,256.024,38.032Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5628",
    "data-name": "Group 5628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5627",
    "data-name": "Group 5627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5626",
    "data-name": "Group 5626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5625",
    "data-name": "Group 5625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5624",
    "data-name": "Group 5624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5623",
    "data-name": "Group 5623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5622",
    "data-name": "Group 5622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5621",
    "data-name": "Group 5621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4653",
    "data-name": "Path 4653",
    d: "M231.618,46.251c-.133-.061-5.384-1.7-5.306,3.693s5.472,4.2,5.479,4.043S231.618,46.251,231.618,46.251Z",
    fill: "#ffbf9d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5637",
    "data-name": "Group 5637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5635",
    "data-name": "Group 5635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5634",
    "data-name": "Group 5634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5632",
    "data-name": "Group 5632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5631",
    "data-name": "Group 5631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5630",
    "data-name": "Group 5630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5629",
    "data-name": "Group 5629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4654",
    "data-name": "Path 4654",
    d: "M230.025,51.991c-.024-.017-.093.067-.25.142a.94.94,0,0,1-.7.025,2.326,2.326,0,0,1-1.1-2.068,3.116,3.116,0,0,1,.244-1.348,1.083,1.083,0,0,1,.695-.731.479.479,0,0,1,.558.249c.074.15.042.258.071.267s.114-.092.067-.314a.6.6,0,0,0-.217-.334.707.707,0,0,0-.521-.13,1.317,1.317,0,0,0-.968.85,3.186,3.186,0,0,0-.3,1.506,2.437,2.437,0,0,0,1.4,2.307,1,1,0,0,0,.857-.155C230.017,52.122,230.044,52,230.025,51.991Z",
    fill: "#ff9a6c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5645",
    "data-name": "Group 5645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5644",
    "data-name": "Group 5644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5642",
    "data-name": "Group 5642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5640",
    "data-name": "Group 5640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5639",
    "data-name": "Group 5639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5638",
    "data-name": "Group 5638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    d: "M253.85,29.5c.86-.5-1.822-3.264-3.987-4.186-3.273-1.393-8.239-2.183-11.205-1.266-3.571,1.1-6.516,2.961-8.244,6.275A21.18,21.18,0,0,0,228.288,41.2a6.428,6.428,0,0,0,.835,3.273c.781,1.174,2.242,1.891,2.217,3.535a2.254,2.254,0,0,0,.6,1.631c1.01,1.026,2.193.013,2.724-.988,1.135-2.138,1.208-4.66,1.256-7.08a15.745,15.745,0,0,0-.46-5.115c-.285-.892-.728-1.731-.963-2.637a3.242,3.242,0,0,1,.319-2.7,3.4,3.4,0,0,1,.428-.452,5.619,5.619,0,0,1,5.549-1.192c3.059,1,8.277,2.485,9.606,1.424a8.31,8.31,0,0,0,2.355-2.5Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5652",
    "data-name": "Group 5652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5651",
    "data-name": "Group 5651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    d: "M248.953,55.374c.021.087-.275.262-.816.329a3.976,3.976,0,0,1-3.659-1.74c-.288-.462-.339-.8-.259-.841.181-.094.834.968,2.155,1.573C247.676,55.338,248.912,55.175,248.953,55.374Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5665",
    "data-name": "Group 5665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4657",
    "data-name": "Path 4657",
    d: "M323.96,42.263s-.208-1.26-.83-1.26a2.208,2.208,0,0,0-1.971,1.26C320.744,43.182,323.96,42.263,323.96,42.263Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4658",
    "data-name": "Path 4658",
    d: "M308.1,62.307l.623-9.932,1.97-10.226s1.556-1.663,2.386-1.277.519,1.754.519,1.754,2.178-2.353,3.008-1.812.518,1.812.518,1.812,1.971-2.612,2.905-1.893,0,1.893,0,1.893,1.236,11.457.614,15.55a7.592,7.592,0,0,1-4.11,5.614l-1.655,6.444-8.126-4.423Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5659",
    "data-name": "Group 5659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4659",
    "data-name": "Path 4659",
    d: "M313.074,49.313l-44.141-.49V45.291l44.141-1.238Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4660",
    "data-name": "Path 4660",
    d: "M359.684,52.813l-62.371-2.634a10.518,10.518,0,0,1-.046-6.893l61.978-2.733C362.1,43.517,362.13,49.763,359.684,52.813Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4661",
    "data-name": "Path 4661",
    d: "M359.075,41.124s-1.88,1.759-1.807,5.59,1.961,5.441,1.961,5.441a8.162,8.162,0,0,0,1.748-6C360.686,42.4,359.075,41.124,359.075,41.124Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5654",
    "data-name": "Group 5654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4662",
    "data-name": "Path 4662",
    d: "M356.582,52.813A4.4,4.4,0,0,1,355.37,51.3a8.706,8.706,0,0,1-1.23-4.527,9.972,9.972,0,0,1,1.094-4.557,3.782,3.782,0,0,1,1.214-1.517c.067.055-.409.621-.884,1.68a11.33,11.33,0,0,0-.9,4.4,9.589,9.589,0,0,0,1.033,4.342C356.208,52.172,356.648,52.763,356.582,52.813Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5655",
    "data-name": "Group 5655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4663",
    "data-name": "Path 4663",
    d: "M359.361,40.694c.068.052-.39.637-.886,1.7a9.95,9.95,0,0,0-.951,4.4,10.067,10.067,0,0,0,1.116,4.364,4.852,4.852,0,0,0,1.108,1.5c-.011.028-.21,0-.5-.211a3.805,3.805,0,0,1-.933-1.113,9.058,9.058,0,0,1-.172-9.114A4.152,4.152,0,0,1,359.361,40.694Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4664",
    "data-name": "Path 4664",
    d: "M360.175,43.894a1.558,1.558,0,0,0-.333-.547.669.669,0,0,0-.586-.2.609.609,0,0,0-.433.429.9.9,0,0,0,.067.622c.225.452.6.87.584,1.321a12.178,12.178,0,0,0-.089,1.346.93.93,0,0,0,.145.467.462.462,0,0,0,.422.208c.267-.036.4-.339.461-.6A5.07,5.07,0,0,0,360.175,43.894Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5656",
    "data-name": "Group 5656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4665",
    "data-name": "Path 4665",
    d: "M297.3,50.4a5.855,5.855,0,0,1-.853-3.581,5.859,5.859,0,0,1,.974-3.551c.146.056-.432,1.587-.453,3.559C296.925,48.8,297.451,50.35,297.3,50.4Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5658",
    "data-name": "Group 5658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4666",
    "data-name": "Path 4666",
    d: "M268.842,49.661h0a.674.674,0,0,1-.674-.674V45.252a.674.674,0,0,1,.674-.674h0a.674.674,0,0,1,.674.674v3.735A.674.674,0,0,1,268.842,49.661Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5657",
    "data-name": "Group 5657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4667",
    "data-name": "Path 4667",
    d: "M268.842,49.661c-.005-.043.178-.047.361-.23a.584.584,0,0,0,.165-.4c-.012-.232-.024-.465-.036-.7-.018-.6-.037-1.222-.056-1.86-.005-.36-.01-.725-.015-1.1a.432.432,0,1,0-.838,0c-.005.373-.01.738-.015,1.1-.019.638-.038,1.256-.056,1.86-.012.237-.024.47-.036.7a.584.584,0,0,0,.165.4c.184.183.366.187.361.23.01.023-.19.112-.489-.073a.767.767,0,0,1-.327-.529c-.014-.241-.028-.482-.042-.728-.018-.6-.037-1.222-.056-1.86-.005-.36-.01-.725-.015-1.1a1.017,1.017,0,0,1,.206-.71.929.929,0,0,1,1.447,0,1.02,1.02,0,0,1,.2.71c-.005.373-.01.738-.015,1.1-.019.638-.038,1.256-.056,1.86q-.021.367-.042.727a.766.766,0,0,1-.327.53C269.032,49.773,268.833,49.684,268.842,49.661Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4668",
    "data-name": "Path 4668",
    d: "M276.506,57.056s-.938-11.59-.66-12.606c.319-1.164,3.478-4.6,4.6-4.72s1.242,1.117,1.242,1.117a6.88,6.88,0,0,1,3.106-1.126,1.7,1.7,0,0,1,1.842,1.386,3.349,3.349,0,0,1,2.472-.39c.658.119,1.413,1.287,1.413,1.287s1.638-.706,2.417.025a3.894,3.894,0,0,1,.968,2.562,4.9,4.9,0,0,0-2.9.923,62.166,62.166,0,0,1-1,7.506c-.621,2.484-3.077,4.536-3.9,5.822l-.652,8.572L274.9,61.826Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5660",
    "data-name": "Group 5660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4669",
    "data-name": "Path 4669",
    d: "M278.881,45.322a3.92,3.92,0,0,1,.873-3.006,3.917,3.917,0,0,1,2.526-1.849c.072.138-1.163.784-2.1,2.148A18.675,18.675,0,0,0,278.881,45.322Z",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5661",
    "data-name": "Group 5661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4670",
    "data-name": "Path 4670",
    d: "M284.042,45.122a3.04,3.04,0,0,1,.436-2.75,3.121,3.121,0,0,1,1.548-1.317c.5-.177.832-.136.839-.076.039.144-1.213.4-1.945,1.667A12.886,12.886,0,0,0,284.042,45.122Z",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5662",
    "data-name": "Group 5662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    d: "M287.818,44.735c-.135-.024.091-1.126,1.078-2.015s2.1-1.019,2.108-.883c.039.147-.9.47-1.758,1.268S287.961,44.788,287.818,44.735Z",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5664",
    "data-name": "Group 5664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4672",
    "data-name": "Path 4672",
    d: "M314.8,59.911c1.763-2.074.419-7.636.419-7.636a5.078,5.078,0,0,0,3.112-3.319c.622-2.49-.623-2.905-.623-2.905-.415.208-4.253,2.7-6.223,3.734s-2.593,11.6-2.593,11.6",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5663",
    "data-name": "Group 5663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4673",
    "data-name": "Path 4673",
    d: "M308.89,61.386a6.27,6.27,0,0,1,0-1.385c.045-.89.136-2.176.332-3.759a22.41,22.41,0,0,1,1.235-5.494,3.709,3.709,0,0,1,.423-.739,1.909,1.909,0,0,1,.711-.566c.477-.262.96-.544,1.449-.836l3.011-1.85c.519-.319.995-.629,1.537-.937l.1-.057.1.043a1.539,1.539,0,0,1,.832.973,3.024,3.024,0,0,1,.127,1.144,5.224,5.224,0,0,1-.549,2.066,5.4,5.4,0,0,1-2.912,2.492l.142-.257a15.489,15.489,0,0,1,.284,5.733,4.667,4.667,0,0,1-.544,1.52c-.219.306-.356.447-.37.434a2.221,2.221,0,0,1,.255-.5,5.347,5.347,0,0,0,.412-1.5,16.57,16.57,0,0,0-.459-5.591l-.042-.184.184-.073a5.007,5.007,0,0,0,2.614-2.3,4.788,4.788,0,0,0,.478-1.871,1.637,1.637,0,0,0-.616-1.6l.2-.014c-.468.269-.989.6-1.494.916-1.029.641-2.038,1.264-3.026,1.847-.494.291-.983.572-1.473.835a1.357,1.357,0,0,0-.56.428,3.29,3.29,0,0,0-.374.638,23.783,23.783,0,0,0-1.307,5.346c-.241,1.566-.387,2.843-.494,3.725A8.05,8.05,0,0,1,308.89,61.386Z",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5667",
    "data-name": "Group 5667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    d: "M232.3,152.592s1.227,50.331,0,56.469-3.274,31.508-3.274,50.331.79,23.112.79,23.112H248.1s1.261-35.788,6.9-56.488c5.239-19.228,11.271-48.463,11.271-61.148V147.682H233.942Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4675",
    "data-name": "Path 4675",
    d: "M276.5,147.682s19.17,53.195,20.4,68.744,1.29,66.078,1.29,66.078h-18.92l-2.528-61.03-14.561-39.542v-34.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5666",
    "data-name": "Group 5666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4676",
    "data-name": "Path 4676",
    d: "M266.268,176.325a7.957,7.957,0,0,1-.235,1.449c-.2,1.021-.453,2.338-.759,3.92-.653,3.406-1.52,7.934-2.479,12.94-.978,5.054-1.9,9.624-2.63,12.918-.365,1.647-.684,2.976-.922,3.89a7.871,7.871,0,0,1-.432,1.4,7.894,7.894,0,0,1,.234-1.448c.2-1.021.453-2.338.76-3.92.652-3.406,1.52-7.935,2.479-12.942.978-5.052,1.9-9.622,2.629-12.916.366-1.647.685-2.976.923-3.89A7.9,7.9,0,0,1,266.268,176.325Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5678",
    "data-name": "Group 5678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    d: "M283.757,171.172h4.053s.929-14.033-1.414-23.49S272.1,97.04,272.1,97.04L258.857,75.156l-7.1-3.187,23.323,78.187Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    d: "M269.009,103.239s12.262,36.328,14.292,45.852a213.572,213.572,0,0,1,3.083,22.081h-2.627l-9.626-25.36s-10.035-40.327-9.567-40.227S269.009,103.239,269.009,103.239Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4679",
    "data-name": "Path 4679",
    d: "M229.5,71.122l1.1-6.961,19.554,8.778V68.674L258.8,83.088l19.009,54.043c.616,1.665,1.351,7.214.245,8.6l-1.554,1.949-20.6,2.664L236.359,79.811Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4680",
    "data-name": "Path 4680",
    d: "M232.738,176.325s26.162,2.937,31.523.8a9.059,9.059,0,0,0,5.615-7.6s2.624-18.577,2.441-22.671a80.986,80.986,0,0,0-1.7-11.276l-37.925,37.468Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4681",
    "data-name": "Path 4681",
    d: "M252.443,79.189s8.941,30.437,8.865,30.664,9.917,31.173,9.917,31.173l1.964-9.3-13.9-46.4L253.7,78.479Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4682",
    "data-name": "Path 4682",
    d: "M223.694,73.962c-9.173,5.586-9.649,14.263-5.568,24.2.677,1.648,1.977,4.485,2.881,6.405,3.947,8.388,12.137,22.078,12.136,25.281,0,7.533-6.749,42.506-6.749,42.506s36.574,4.441,39.874.987,5.841-25,4.78-34.642c-1.172-10.639-6.652-28.632-8.872-35.293-1.336-4.007-5.75-13.987-11.013-20.528a60,60,0,0,0-13.875-12.568l-7.785-5.1-1.605,5.4A28.183,28.183,0,0,1,223.694,73.962Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4683",
    "data-name": "Path 4683",
    d: "M259.293,76.389c.753-.041,34.183,10.925,32.252,10.117l.892-.932,12.047-18.16,10.974,6.507S304.57,94.726,302.772,97.985a9.991,9.991,0,0,1-8.87,5.254c-2.452,0-23.388-3.5-23.388-3.5Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4684",
    "data-name": "Path 4684",
    d: "M272.74,63.893l2.588-4.58,11.644,6.623-1.815,5.043Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4685",
    "data-name": "Path 4685",
    d: "M221.526,98.513s22.5,12.531,29.624,14.181,15.118,3.937,15.118,3.937l-3.208-10.218L243.533,94.54Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5669",
    "data-name": "Group 5669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4686",
    "data-name": "Path 4686",
    d: "M221.526,98.513c-.277-.212,33.717,11.879,40.642,9.7s9.175-9.048,11.651-13.273c4.533-7.733,12.565-23.105,12.565-23.105L271.964,63.6,257.64,87.572S232.333,77.139,230,76.458s-9.539-1.615-13.064,6.807C213.03,92.6,221.526,98.513,221.526,98.513Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5668",
    "data-name": "Group 5668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    d: "M221.526,98.513a1.89,1.89,0,0,1-.254-.167c-.163-.119-.4-.3-.7-.563a15.285,15.285,0,0,1-2.348-2.57,12.722,12.722,0,0,1-2.235-5.1,10.527,10.527,0,0,1-.188-1.705c-.035-.591.053-1.2.079-1.833.139-.615.216-1.268.419-1.9a15.976,15.976,0,0,1,.721-1.93,13.086,13.086,0,0,1,2.421-3.718,9.871,9.871,0,0,1,4.078-2.627,11.12,11.12,0,0,1,5.23-.4,11.432,11.432,0,0,1,2.67.763l2.647,1.019c7.139,2.811,15.089,6.059,23.665,9.575l-.3.1,14.311-23.975.131-.219.221.126,5.185,2.958,9.234,5.273.217.123-.116.221c-2.833,5.4-5.622,10.622-8.365,15.621-1.374,2.5-2.734,4.939-4.113,7.3-1.362,2.341-2.442,4.807-3.889,7a16.114,16.114,0,0,1-5.387,5.384,11.372,11.372,0,0,1-3.437,1.334,15.7,15.7,0,0,1-3.55-.022,87.691,87.691,0,0,1-12.506-2.561c-7.514-2.015-13.452-3.973-17.54-5.324s-6.3-2.173-6.3-2.173a1.371,1.371,0,0,1,.422.1l1.225.382,4.712,1.51c4.1,1.294,10.057,3.2,17.569,5.168a88.5,88.5,0,0,0,12.457,2.488,15.415,15.415,0,0,0,3.449.011,11.016,11.016,0,0,0,3.279-1.293,15.684,15.684,0,0,0,5.219-5.256c1.417-2.158,2.482-4.607,3.86-6.99,1.371-2.358,2.725-4.8,4.093-7.3,2.732-5,5.516-10.225,8.344-15.62l.1.344-9.237-5.269-5.183-2.959.351-.093c-5.052,8.443-9.9,16.544-14.338,23.959l-.108.181-.194-.08c-8.567-3.532-16.509-6.8-23.631-9.643l-2.636-1.028a11.06,11.06,0,0,0-2.589-.754,10.766,10.766,0,0,0-5.059.363,9.542,9.542,0,0,0-3.95,2.514,12.805,12.805,0,0,0-2.388,3.614,15.625,15.625,0,0,0-.722,1.886c-.205.623-.283,1.259-.426,1.86-.03.616-.122,1.214-.094,1.792a10.5,10.5,0,0,0,.167,1.67,12.7,12.7,0,0,0,2.136,5.048,16.286,16.286,0,0,0,2.273,2.6c.286.27.515.463.669.591Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5671",
    "data-name": "Group 5671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4688",
    "data-name": "Path 4688",
    d: "M237.873,149.739l3.15-6.377,22.037.387-2.449,6.6Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5670",
    "data-name": "Group 5670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    d: "M237.872,149.739a4.336,4.336,0,0,1,.481-.012l1.31.008,4.8.059c4.067.055,9.7.138,16.155.3l-.244.165,2.333-6.3.11-.3.239.351c-8.87-.157-16.795-.332-22.035-.479l.154-.094-2.382,4.591-.664,1.257a4.586,4.586,0,0,1-.256.454,2.8,2.8,0,0,1,.172-.41l.573-1.247,2.255-4.794.044-.1h.11c5.242.036,13.168.14,22.038.295l.368.007-.128.344-.11.3-2.346,6.3-.063.171-.181,0c-6.586-.187-12.325-.408-16.366-.569l-4.719-.2-1.243-.061A2.19,2.19,0,0,1,237.872,149.739Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5672",
    "data-name": "Group 5672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    d: "M252.585,84.761c-.072.125-5.657-2.943-12.473-6.851s-12.286-7.179-12.214-7.3,5.655,2.943,12.473,6.852S252.656,84.636,252.585,84.761Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5673",
    "data-name": "Group 5673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    d: "M260.2,132.881c-.009.144-5.318-.079-11.857-.5s-11.834-.875-11.824-1.018,5.317.079,11.857.5S260.214,132.738,260.2,132.881Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    d: "M305.173,67.9l2.213-3.737,8.8,5.14-1.712,4.056Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5674",
    "data-name": "Group 5674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    d: "M293.839,94.193a9.115,9.115,0,0,1-2.582-7.5c.157,0,.2,1.807.926,3.875C292.885,92.645,293.965,94.1,293.839,94.193Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5675",
    "data-name": "Group 5675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    d: "M272.308,97.759A41.8,41.8,0,0,1,274.381,104a41.748,41.748,0,0,1,1.573,6.389,41.6,41.6,0,0,1-2.073-6.244A41.714,41.714,0,0,1,272.308,97.759Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5676",
    "data-name": "Group 5676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M258.811,95.153a7.562,7.562,0,0,1-1.29-7.671,25.565,25.565,0,0,0,.1,3.928A25.766,25.766,0,0,0,258.811,95.153Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M239.639,149.777l-.389,1.931,22.82.644.99-8.6-2.449,6.6Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M249.676,77.15l.24.259,2.526,1.78,1.26-.711-.823-2.79-2.661-1.995Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5677",
    "data-name": "Group 5677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M253.082,73.694a12.07,12.07,0,0,1,.564,2.409l.081.426-.364-.255c-.882-.619-2.019-1.441-3.3-2.38l.4-.161c-.119.784-.246,1.617-.378,2.481-.083.516-.163,1.022-.241,1.509l-.055.344-.31-.152c-1.917-.941-3.594-1.788-4.784-2.416a9.911,9.911,0,0,1-1.867-1.091,9.931,9.931,0,0,1,2.014.788c1.23.545,2.934,1.335,4.86,2.257l-.365.191.233-1.511c.139-.863.273-1.694.4-2.478l.067-.413.33.252c1.26.96,2.367,1.822,3.209,2.495l-.283.17A12.056,12.056,0,0,1,253.082,73.694Z",
    fill: "#263238"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.8f1fb71b34fd1894343c09c89432d5de.svg";
export { ForwardRef as ReactComponent };